import { render } from "./InputColor.vue?vue&type=template&id=3df007f8&scoped=true"
import script from "./InputColor.vue?vue&type=script&lang=js"
export * from "./InputColor.vue?vue&type=script&lang=js"

import "./InputColor.vue?vue&type=style&index=0&id=3df007f8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df007f8"]])

export default __exports__